import { enUS, nn } from 'date-fns/locale'

import i18n from 'utils/i18n'

export const getDateFormatLocale = (): Locale => {
  const currentLocale = i18n.language

  return currentLocale === 'no' ? nn : enUS
}
